export const viewRoleDialogTranslations = {
    en: {
        submit: "Submit",
        updateSuccess: "Role updated successfully",
        updateError: "Failed to update role",
        noRoleDetails: "No role details available."
    },
    mr: {
        submit: "सबमिट करा",
        updateSuccess: "भूमिका यशस्वीरित्या अपडेट केली",
        updateError: "भूमिका अपडेट करण्यात अयशस्वी",
        noRoleDetails: "भूमिका तपशील उपलब्ध नाही."
    }
};
